export const MESSAGE_ID_ATTRIBUTE_NAME = 'data-message-id';

export function findMessageNodeById(
  messageId: string,
  parentNode: HTMLElement | Document = document
): HTMLElement | null {
  return parentNode.querySelector<HTMLElement>(`[${MESSAGE_ID_ATTRIBUTE_NAME}="${messageId}"]`);
}
